import { Link } from "react-router-dom";
import { Cookie, Apple, Candy, Croissant, Check, ArrowRight } from "lucide-react";

const SnackMachines = () => {
  const features = [
    "Up to 45 product selections",
    "Glass front display",
    "Spiral delivery system",
    "Guaranteed product drop",
    "Digital payment ready",
    "Temperature options available",
  ];

  return (
    <div className="min-h-screen" data-testid="snack-machines-page">
      {/* Hero */}
      <section className="py-16 md:py-24 bg-navy relative overflow-hidden" data-testid="snack-hero">
        <div className="absolute bottom-20 left-10 w-8 h-8 bg-gold rotate-45 opacity-60" style={{ clipPath: 'polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%)' }} />
        
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <span className="inline-block bg-gold text-navy font-mono text-sm px-4 py-2 rounded-full border-2 border-navy mb-6">
                SNACK MACHINES
              </span>
              <h1 className="font-heading text-4xl md:text-5xl text-cream mb-4">
                Satisfying Snacks, <span className="text-coral">Anytime</span>
              </h1>
              <p className="text-cream/80 text-lg mb-8">
                From crispy chips to healthy bites, our snack machines offer the
                variety your team craves with the reliability they deserve.
              </p>
              <Link
                to="/contact"
                className="btn-primary inline-flex items-center gap-2"
                data-testid="snack-cta"
              >
                Get a Snack Machine <ArrowRight className="h-5 w-5" />
              </Link>
            </div>
            <div className="flex justify-center">
              <div className="bg-coral/20 rounded-2xl p-8 border-2 border-cream/20">
                <Cookie className="h-32 w-32 text-cream mx-auto" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Snack Types */}
      <section className="py-20 md:py-32" data-testid="snack-types-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="font-heading text-3xl md:text-4xl text-navy mb-4">
              Snacks Everyone Loves
            </h2>
            <p className="text-navy/70 max-w-2xl mx-auto">
              We analyze purchasing patterns to stock exactly what your users
              want—no more forgotten snacks collecting dust.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* Chips & Crackers */}
            <div className="card-retro" data-testid="snack-type-chips">
              <div className="bg-gold/30 w-14 h-14 rounded-xl flex items-center justify-center mb-4">
                <Cookie className="h-7 w-7 text-navy" />
              </div>
              <h3 className="font-heading text-xl text-navy mb-4">Chips & Crackers</h3>
              <ul className="space-y-2">
                <li className="text-navy/70 text-sm flex items-center gap-2">
                  <span className="w-1.5 h-1.5 bg-coral rounded-full" />Lay's
                </li>
                <li className="text-navy/70 text-sm flex items-center gap-2">
                  <span className="w-1.5 h-1.5 bg-coral rounded-full" />Doritos
                </li>
                <li className="text-navy/70 text-sm flex items-center gap-2">
                  <span className="w-1.5 h-1.5 bg-coral rounded-full" />Cheez-Its
                </li>
                <li className="text-navy/70 text-sm flex items-center gap-2">
                  <span className="w-1.5 h-1.5 bg-coral rounded-full" />Goldfish
                </li>
              </ul>
            </div>

            {/* Candy & Chocolate */}
            <div className="card-retro" data-testid="snack-type-candy">
              <div className="bg-gold/30 w-14 h-14 rounded-xl flex items-center justify-center mb-4">
                <Candy className="h-7 w-7 text-navy" />
              </div>
              <h3 className="font-heading text-xl text-navy mb-4">Candy & Chocolate</h3>
              <ul className="space-y-2">
                <li className="text-navy/70 text-sm flex items-center gap-2">
                  <span className="w-1.5 h-1.5 bg-coral rounded-full" />M&Ms
                </li>
                <li className="text-navy/70 text-sm flex items-center gap-2">
                  <span className="w-1.5 h-1.5 bg-coral rounded-full" />Snickers
                </li>
                <li className="text-navy/70 text-sm flex items-center gap-2">
                  <span className="w-1.5 h-1.5 bg-coral rounded-full" />Skittles
                </li>
                <li className="text-navy/70 text-sm flex items-center gap-2">
                  <span className="w-1.5 h-1.5 bg-coral rounded-full" />Twix
                </li>
              </ul>
            </div>

            {/* Healthy Options */}
            <div className="card-retro" data-testid="snack-type-healthy">
              <div className="bg-gold/30 w-14 h-14 rounded-xl flex items-center justify-center mb-4">
                <Apple className="h-7 w-7 text-navy" />
              </div>
              <h3 className="font-heading text-xl text-navy mb-4">Healthy Options</h3>
              <ul className="space-y-2">
                <li className="text-navy/70 text-sm flex items-center gap-2">
                  <span className="w-1.5 h-1.5 bg-coral rounded-full" />Nuts & Trail Mix
                </li>
                <li className="text-navy/70 text-sm flex items-center gap-2">
                  <span className="w-1.5 h-1.5 bg-coral rounded-full" />Granola Bars
                </li>
                <li className="text-navy/70 text-sm flex items-center gap-2">
                  <span className="w-1.5 h-1.5 bg-coral rounded-full" />Dried Fruit
                </li>
                <li className="text-navy/70 text-sm flex items-center gap-2">
                  <span className="w-1.5 h-1.5 bg-coral rounded-full" />Protein Bars
                </li>
              </ul>
            </div>

            {/* Fresh & Pastry */}
            <div className="card-retro" data-testid="snack-type-pastry">
              <div className="bg-gold/30 w-14 h-14 rounded-xl flex items-center justify-center mb-4">
                <Croissant className="h-7 w-7 text-navy" />
              </div>
              <h3 className="font-heading text-xl text-navy mb-4">Fresh & Pastry</h3>
              <ul className="space-y-2">
                <li className="text-navy/70 text-sm flex items-center gap-2">
                  <span className="w-1.5 h-1.5 bg-coral rounded-full" />Pastries
                </li>
                <li className="text-navy/70 text-sm flex items-center gap-2">
                  <span className="w-1.5 h-1.5 bg-coral rounded-full" />Muffins
                </li>
                <li className="text-navy/70 text-sm flex items-center gap-2">
                  <span className="w-1.5 h-1.5 bg-coral rounded-full" />Cookies
                </li>
                <li className="text-navy/70 text-sm flex items-center gap-2">
                  <span className="w-1.5 h-1.5 bg-coral rounded-full" />Pop-Tarts
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="py-20 md:py-32 bg-gold/20" data-testid="features-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="bg-white rounded-2xl border-2 border-navy p-8 shadow-[8px_8px_0px_0px_#E07A5F]">
              <div className="text-center">
                <div className="font-mono text-coral text-sm mb-2">SELECTIONS</div>
                <div className="font-heading text-5xl text-navy mb-4">45</div>
                <p className="text-navy/70">Different snack options per machine</p>
              </div>
            </div>
            <div>
              <span className="inline-block bg-cream text-navy font-mono text-sm px-4 py-2 rounded-full border-2 border-navy mb-6">
                MACHINE FEATURES
              </span>
              <h2 className="font-heading text-3xl md:text-4xl text-navy mb-6">
                Built for Satisfaction
              </h2>
              <ul className="space-y-4">
                {features.map((feature, index) => (
                  <li key={index} className="flex items-center gap-3">
                    <div className="bg-matcha w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0">
                      <Check className="h-4 w-4 text-cream" />
                    </div>
                    <span className="text-navy">{feature}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 md:py-32 bg-coral" data-testid="cta-section">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="font-heading text-3xl md:text-4xl text-cream mb-4">
            Snack Time Made Simple
          </h2>
          <p className="text-cream/90 mb-8 max-w-xl mx-auto">
            Get a zero-cost snack machine for your space today.
          </p>
          <Link
            to="/contact"
            className="btn-secondary inline-block"
            data-testid="cta-button"
          >
            Request Your Machine
          </Link>
        </div>
      </section>
    </div>
  );
};

export default SnackMachines;
